import { get } from 'lodash';
import { createSelector } from 'reselect';

const patientsSelector = state => get(state, ['dal', 'patients', 'patients']);

export const currentPatientIdSelector = state =>
  get(state, ['dal', 'patients', 'currentPatientId']);

export const currentPatientSelector = createSelector(
  [patientsSelector, currentPatientIdSelector],
  (patients, id) => get(patients, id),
);



// WEBPACK FOOTER //
// ./src/lib/dataLayer/patient/selectors.js